var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header row-between",attrs:{"min":_vm.min,"minifybyview":_vm.minifybyview,"cat":_vm.$route.params.id}},[_c('router-link',{staticClass:"contenedor-logo",attrs:{"to":"/"}},[_c('img',{attrs:{"src":"/static/img/logo.svg","width":"160","alt":"Logo"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-546db7fa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/header.vue
// module id = null
// module chunks = 